import FuxHTTP from "../../lib/FuxFramework/FuxHTTP";
import APIConfig from "../APIConfig";
import AuthAPI from "../AuthAPI";

export const _Files = {
    getFiles: (id_dipendente, tags_csv) => {
        const params = {
            id_dipendente: id_dipendente,
            token: AuthAPI.getUserAccessToken()
        };
        if (tags_csv) {
            params.tags_csv = tags_csv;
        }

        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url("/modulo-hr/files/get-files"),
            params,
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    }
};
